import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import React from "react";
import Pagination from "../../Components/Pagination";
import {useOpenProjectSettlements, useProjectSettlements} from "../../Apis/ProjectSettlementApi";
import ProjectSettlementListFilter from "../../Features/Settlements/ProjectSettlementListFilter";
import ProjectSettlementList from "../../Features/Settlements/ProjectSettlementList";
import useQueryParams from "../../Hooks/UseQueryParams";
import CalculatorIcon from "../../Assets/SVG/CalculatorIcon";
import Space from "../../Components/Space";
import Button from "../../Components/Button";
import moment from "moment";
import Separator from "../../Components/Separator";
import {useNavigate} from "react-router-dom";

const Index = () => {

    const { t } = useTranslation();

    const [ filter, setFilter ] = useQueryParams();
    
    const { data: openSettlements, isLoading: isLoadingOpen } = useOpenProjectSettlements(filter);
    const { data: closedSettlements, isLoading: isLoadingClosed } = useProjectSettlements(filter);
    
    const navigate = useNavigate();
    
    return (
        <PageLayout title={t('settlements')} icon={<CalculatorIcon />}>
            <>
                <ProjectSettlementListFilter filterUpdated={setFilter} currentValue={filter} />

                <div>
                    <Separator style={{margin: '30px 0'}}/>

                    <div style={{width: 'fit-content'}}>
                        <Space direction={"horizontal"} size={"small"}>
                            <Button type={"tertiary"} text={t('settlementSales')} onClick={() => navigate(`/settlements/settlementSales?showType=orders&from=${moment().startOf('month').format('YYYY-MM-DD')}&to=${moment().endOf('month').format('YYYY-MM-DD')}&includeUnfulfilled=false`)} />
                            <Button type={"tertiary"} text={t('zettleSales')} onClick={() => navigate(`/settlements/zettleSales?from=${moment().startOf('month').format('YYYY-MM-DD')}&to=${moment().endOf('month').format('YYYY-MM-DD')}`)} />
                            <Button type={"tertiary"} text={t('settlementSettings')} onClick={() => navigate(`/settlements/settlementSettings`)} />
                            <Button type={"tertiary"} text={t('shopifyShops')} onClick={() => navigate(`/settlements/shopifyOrderIntegrations`)} />
                        </Space>
                    </div>

                    <Separator style={{margin: '30px 0'}}/>
                </div>

                {openSettlements && openSettlements.length > 0 && (
                    <>
                        <ProjectSettlementList isLoading={isLoadingOpen} projectSettlements={openSettlements} />
                        
                        <Separator style={{margin: '30px 0'}}/>
                    </>
                )}
                
                
                <ProjectSettlementList isLoading={isLoadingClosed} projectSettlements={closedSettlements?.items} />

                <Pagination paginatedList={closedSettlements} onPageChange={newPage => setFilter({page: newPage})} />
            </>
        </PageLayout>
    )
}

export default Index
